var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es399.js.map
